import type { BusinessModeFieldType } from '../../types';

const ALLOWED_TYPES = new Set(['string', 'number', 'text', 'select', 'select-multi', 'date']);

export const normalizeModeFields = (fields: unknown): BusinessModeFieldType[] => {
    if (!Array.isArray(fields)) return [];

    return fields
        .map((item) => ({
            title: String((item as { title?: unknown })?.title || ''),
            i18nKey: String((item as { i18nKey?: unknown })?.i18nKey || ''),
            type: String((item as { type?: unknown })?.type || 'string'),
            selectValues: Array.isArray((item as { selectValues?: unknown[] })?.selectValues)
                ? ((item as { selectValues?: unknown[] }).selectValues || []).map((v) => String(v || '')).filter(Boolean)
                : [],
        }))
        .filter((item) => ALLOWED_TYPES.has(item.type))
        .map((item) => ({
            ...item,
            type: item.type as BusinessModeFieldType['type'],
        }));
};
